module.exports = __webpack_public_path__ + "img/Ferrari.668bdb1d.png";